<div class="form-field">
  @if (label) {
    <label class="form-field__label">
      {{ label }}
      @if (required) {
        <span class="form-field__required">*</span>
      }
    </label>
  }

  <input
    [type]="date"
    [id]="formControlName"
    [placeholder]="placeholder"
    [required]="required"
    [disabled]="control?.disabled || disabled"
    [value]="value"
    (input)="onInput($event)"
    (focus)="setMinDateTime()"
    (blur)="onTouched()"
    [min]="minDateTime"
    step="60"
    class="form-field__input form-field__input--{{ size }}"
    [ngClass]="{
      'form-field__input--invalid': isInvalid,
      'form-field__input--disabled': control?.disabled
    }"
  />

  @if (errorMessage) {
    <div class="form-field__error">{{ errorMessage }}</div>
  }
</div>
